import api from 'services/api';
export function startCheckout(objArgs) {
    if (typeof (objArgs) !== "object" || !objArgs.hasOwnProperty("id") || 
        !objArgs.hasOwnProperty("currency") || !objArgs.hasOwnProperty("amount")) {
        throw new Error('missing required parameters');
    }
    return api.post('checkout', JSON.stringify({ id: objArgs.id, currency: objArgs.currency, amount: objArgs.amount, region: objArgs.region, name: objArgs.title }));
}

export function getCheckoutItems(objArgs) {
    if (typeof (objArgs) !== "object" || !objArgs.hasOwnProperty("locale")) {
        throw new Error('missing required parameters');
    }
    return api.get('checkout/items?locale=' + objArgs.locale);
}

export function getCheckoutItemsPublic(objArgs) {
    if (typeof (objArgs) !== "object" || !objArgs.hasOwnProperty("locale")) {
        throw new Error('missing required parameters');
    }
    return api.get('checkout/items?locale=' + objArgs.locale);
}

export function getCheckoutConfirmation(objArgs) {
    if (typeof (objArgs) !== "object" || !objArgs.hasOwnProperty("id")) {
        throw new Error('missing required parameters');
    }
    return api.get('checkout/' + objArgs.id + '/status');
}

export function postRazorPayTransaction(objArgs) {
    if (typeof (objArgs) !== "object") {
        throw new Error('missing required parameters');
    }
    return api.post("checkout/razorpay/transaction", JSON.stringify(objArgs));
}

export function postKlashaTransaction(objArgs) {
    if (typeof (objArgs) !== "object") {
        throw new Error('missing required parameters');
    }
    return api.post("checkout/klasha/transaction", JSON.stringify(objArgs));
}